<template>
<div class="active_banquets">
  <div class="ui centered inline loader" :class="{'active': form.waiting}"></div>
  <div class="ui form">
    <div class="fields">
      <div class="field">
        <label>これより前の日付で集計</label>
        <datepick v-model="form.model.banquets_marunage_event_date_to" :placeholder="'終了日'" @change="search()"></datepick>
      </div>
      <div style="display: inline-block; position: absolute; right: 0; bottom: 0;">
        <button @click="download" type="button" class="ui small yellow button"><i class="download icon"></i>CSVでダウンロードする</button>
      </div>
    </div>
  </div>
  <pagination :pager="pager" :callback="search"></pagination>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>店舗名</th>
        <th>案件数</th>
        <th>一番古い希望日</th>
        <th>電話番号</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="shop in shops" :key="shop.id">
        <td>
          <a class="clickable" :href="shop.auth_url + '?redirect=/shopadmin/banquets'" target="_blank">{{ shop.name }}</a>
        </td>
        <td>{{ shop.active_count }}件</td>
        <td>{{ shop.oldest_event_date | formatDate }}</td>
        <td>{{ shop.tel }}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            form: this.createForm(_.defaults(this.query(), {
                'banquets_marunage_event_date_to': moment().format('YYYY/MM/DD')})),
            pager: this.createPager(15),
            shops: [],
        };
    },
    created: function() {
        this.search(this.pager.current());
    },
    methods: {
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.form.model, position);
            this.replaceStateQuery(this.form.model, ['limit']);
            this.form.get('/afadmin/api/shops/active_banquets', function(response) {
                this.shops = response.data;
                this.pager.update(response.data, response);
            }.bind(this));
        },
        download: function() {
            var link = document.createElement('a');
            link.href = '/afadmin/api/shops/active_banquets' + window.location.search + '&download';
            document.body.appendChild(link);
            link.click();
        }
    }
};
</script>
